// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1dpSP","validationTips":"StatementDescriptor_validationTips__2v_38"};